module.exports = __webpack_public_path__ + "img/icon_four_bottom_2.64469f48.png";